import styled from 'styled-components'
import InputGroup from '../components/InputGroup'
import colors from '../lib/colors'
import theme, { ZIndex } from '../lib/theme'
import { Order } from './tableTypes'

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    padding: 5px;
    text-align: left;
  }
  tr {
    background-color: ${colors.white};
    :nth-child(odd) {
      background-color: ${colors.lightestGray};
    }
    :hover {
      background-color: ${colors.lightGray};
    }
    &.table-row-link {
      cursor: pointer;
    }
  }
  th {
    white-space: nowrap;
    background: ${colors.white};
    border-style: solid;
    border-width: 1px;
    border-color: ${colors.gray};
    &.table-hidden-parent {
      border: none;
    }
    &.table-header-sortable {
      cursor: pointer;
      user-select: none;
    }
  }
  tbody {
    border: 1px solid ${colors.gray};
  }
  ${({ theme: { isMobile } }): string => isMobile && 'font-size: 0.9rem;'};
`
const arrow = `
  border-width: 5px 0 5px 8px;
  border-left-color: ${colors.darkGray};
`
const upArrow = `
  border-width: 0 5px 8px 5px;
  border-bottom-color: ${colors.darkerGray};
`
const downArrow = `
  border-width: 8px 5px 0 5px;
  border-top-color:${colors.darkerGray};
`
export const SortArrow = styled.div`
  display: inline-block;
  border-style: solid;
  margin: 0 10px;
  border-radius: 2px;
  border-color: transparent;
  ${(props): string => {
    if (props.theme === Order.Asc) return upArrow
    if (props.theme === Order.Desc) return downArrow
    return arrow
  }}
`

export const PaginationStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  margin: auto;
`
export const PageButtons = styled.div`
  position: relative;
  background-color: ${colors.white};
  border: 1px solid ${colors.darkGray};
  border-radius: 4px;
  margin: 16px 0 3px;
  height: 28px;
  display: flex;
  button {
    all: unset;
    cursor: pointer;
    min-width: 18px;
    color: ${colors.darkestGray};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 3px;
    :hover {
      color: ${colors.lightBlue};
    }
    :disabled {
      color: ${colors.darkGray};
    }
    svg {
      width: 20px;
      height: auto;
    }
    &.table-current-page {
      color: ${colors.lightBlue};
      font-weight: bold;
    }
  }
`
export const Cover = styled.div`
  background-color: ${colors.faded};
  position: absolute;
  ${theme.inset0};
  z-index: ${ZIndex.AboveContent};
`
export const LoadingLimiter = styled.div`
  height: 100%;
  width: 100%;
  max-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const EmptyRow = styled.tr`
  height: 100px;
  td {
    text-align: center;
  }
`
export const Controls = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 30px;
  justify-content: space-between;
`
export const FilterRow = styled(InputGroup)`
  & .styled-input {
    min-width: 110px;
  }
  margin-bottom: 10px;
`
export const ButtonRow = styled.div`
  margin-left: auto;
  margin-bottom: 10px;
`
export const Records = styled.div`
  font-size: 0.85rem;
  width: 95%;
  display: flex;
  justify-content: space-between;
  & div:only-child {
    margin: 0 auto;
  }
`
export const Cell = styled.td`
  /* so can position things absolutely within cells */
  position: relative;
`
